module.exports = __webpack_public_path__ + "img/m401.89f45881.png";